import { ComponentProps, ReactElement } from 'react'
import { AnimatePresence } from 'framer-motion'
import { HubSettingsMenuItem } from '@/layouts/hub-settings/components'

type Child = ReactElement<ComponentProps<typeof HubSettingsMenuItem>>

interface HubSettingsMenuProps {
  label?: string
  children: Child | Child[]
}

export const HubSettingsMenu = ({ label, children }: HubSettingsMenuProps) => (
  <div className="flex flex-col gap-3">
    {label && <span className="text-caption-xs uppercase text-text-quarterary-hover">{label}</span>}
    <ul>
      <AnimatePresence>{children}</AnimatePresence>
    </ul>
  </div>
)
